var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "166px",
    width: "166px",
    id: "_x34_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EA94AC"
    },
    points: "491.095,274.663 512,209.868 470.595,188.773 491.69,147.361 436.692,107.222 366.311,120.335 353.313,124.566 353.313,110.891 344.038,39.902 288.863,0 256.002,32.854 256.002,424.035 256.002,424.035 264.045,435.111 313.275,487.083 381.354,486.948 388.625,441.041 434.539,448.305 455.701,383.598 421.486,320.719 413.443,309.643 426.455,305.426 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F1A4BD"
    },
    points: "223.141,0 167.966,39.902 158.691,110.891 158.691,124.566 145.689,120.335 75.305,107.235 20.31,147.361 41.408,188.773 0,209.868 20.905,274.663 85.552,305.426 98.564,309.643 90.524,320.719 56.299,383.598 77.478,448.305 123.382,441.041 130.639,486.948 198.728,487.083 247.959,435.111 256.002,424.035 256.002,32.854 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M362.737,245.803c0-9.383-7.596-16.973-16.966-16.973c-9.383,0-16.965,7.59-16.965,16.973 c0,4.813,2.003,9.166,5.24,12.254c-3.601,7.873-10.019,17.371-18.956,26.179c-5.781,5.707-15.354,13.655-28.054,19.26 c5.849-7.914,10.575-17.216,14.216-25.827c6.648-15.686,11.821-34.439,14.177-50.294c6.919-2.146,11.969-8.584,11.969-16.214 c0-9.376-7.609-16.959-16.979-16.959c-9.356,0-16.952,7.583-16.952,16.959c0,6.587,3.751,12.281,9.234,15.097 c-2.085,13.594-7.122,30.763-13.756,46.462c-8.205,19.402-17.967,32.076-27.866,36.111v-94.813 c9.898-2.62,13.933-9.944,13.933-18.59c0-10.819-8.476-19.606-19.308-19.606c-10.832,0-19.633,8.787-19.633,19.606 c0,8.577,5.213,15.862,13.133,18.536v94.826c-9.883-4.042-18.78-16.444-26.93-35.407c-6.621-15.395-10.954-32.286-13.052-45.724 c5.47-2.796,9.274-8.503,9.274-15.083c0-9.376-7.569-16.966-16.938-16.966c-9.383,0-16.966,7.59-16.966,16.966 c0,7.63,5.064,14.082,11.983,16.207c2.356,15.713,7.556,34.202,14.177,49.631c4.346,10.107,9.072,18.57,14.108,25.306 c-23.519-10.081-40.078-29.802-46.889-44.289c3.223-3.074,5.213-7.42,5.213-12.227c0-9.363-7.583-16.959-16.952-16.959 c-9.37,0-16.962,7.596-16.962,16.959c0,9.343,7.552,16.919,16.867,16.959c4.495,9.898,12.213,20.533,21.894,29.842 c19.308,18.523,43.382,28.772,67.794,28.772h0.176h0.108l0,0h1.016v0.331c23.749-0.094,48.013-10.683,67.361-29.726 c9.708-9.546,17.209-20.534,21.678-30.586C355.466,262.714,362.737,255.112,362.737,245.803z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.10eb3f9a189cae7ee9be6914e7eef9ce.svg";
export { ForwardRef as ReactComponent };